import { useReducer } from "react"
import { createContainer } from "react-tracked"
import { useSelector as useCampaignSelector } from "../../../../common/components/campaigncreator/store"
import { initial_ui_state, reducer } from "./reducer"

const useValue = () => {
  const platform = useCampaignSelector((state) => state.config.meta.platform)

  const reducerResult = useReducer(reducer, {
    ...initial_ui_state,
    platform: platform,
  })

  return reducerResult
}

export const {
  Provider,
  useTracked,
  useTrackedState,
  useUpdate: useDispatch,
} = createContainer(useValue)
